import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { goBack } from 'core/routing';
import { staticURL } from 'core/url';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';
import { Button } from 'components';

import { clientStore } from 'apps/client/app';
import { SignUpOrganizationAppManager } from 'apps/profile/signUp/organization/appManager';

import { withNamespaces } from 'react-i18next';

import Image from 'components/Image';
import {
  MainSignInPageWrapper,
  ImageWrapper,
  GoBackWrapper,
  WrapperSignInForm,
  MainSignInFormColumn,
} from 'apps/signIn/styles';

import Logo from 'components/Logo';

@withNamespaces()
@observer
export class SignUpOrganization extends React.Component {
  UNSAFE_componentWillMount() {
    const { signedInProfile, routerStore } = clientStore;
    if (signedInProfile) {
      const {
        route: { params },
      } = routerStore;
      routerStore.navigate('home.newInitiative', params, { replace: true });
    } else {
      this.appManager = new SignUpOrganizationAppManager(null, this.props);
    }
  }

  render() {
    const { t } = this.props;
    if (!this.appManager) {
      return null;
    }
    const { wizard } = this.appManager;
    return (
      <>
        <DocumentHead title={`${t('Sign up Organisation')}`} index='noindex' />
        <MainSignInPageWrapper>
          <GoBackWrapper>
            <Button
              outline
              variant='minimal'
              icon='close_small'
              size='small'
              onClick={() => goBack()}
            />
          </GoBackWrapper>

          <ImageWrapper>
            <Image
              src={staticURL('assets/gridImages/yellow-square-grid.svg')}
              alt='Grid image'
            />
          </ImageWrapper>
          <WrapperSignInForm>
            <MainSignInFormColumn>
              <Logo size='48px' />
              <Wizard isSideBarForm spacing='medium' wizard={wizard} />
            </MainSignInFormColumn>
          </WrapperSignInForm>
        </MainSignInPageWrapper>
      </>
    );
  }
}

SignUpOrganization.propTypes = {
  t: PropTypes.func,
  params: PropTypes.object,
};
